import resellers from "./resellers";

// You can pick based on env variable, API call, or localStorage
const currentReseller = process.env.REACT_APP_RESELLER || "dealerClick";

export const {
	DC_CompanyName,
	DC_Company_Website,
	DC_Company_Logo,
	DC_Login_Logo,
	BrandCode,
	RemoteConnect,
	appUrl,
	isDealerClick,
} = resellers[currentReseller];

/*------------------*/
// --- NEW: load reseller-specific CSS if defined ---
